import { useSyncExternalStore } from 'react'
import { pubSubRouter } from '../../state/pubSub'
import { AppRouter, MfcRouter } from '../../state/state.router'

const getRoute =
    <T extends keyof MfcRouter['route']>(attribute: T) =>
    (): MfcRouter['route'][T] =>
        AppRouter.route[attribute]
const subRoute = (callback) => pubSubRouter.on('change', callback)

export const useRouteSelector = <T extends keyof MfcRouter['route']>(
    attribute: T,
): MfcRouter['route'][T] => {
    return useSyncExternalStore(
        subRoute,
        getRoute(attribute),
        getRoute(attribute),
    )
}
